import { render, staticRenderFns } from "./personToCover.vue?vue&type=template&id=b98e6b3a&"
import script from "./personToCover.vue?vue&type=script&lang=ts&"
export * from "./personToCover.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports